/** @jsx jsx */
import { jsx } from '@emotion/core';
import { hasAfterStyles, hasBeforeStyles, linkStyles, roundedBorderStyles, textStyles } from './styles';

var Content = function Content(props) {
  var _props$elemBefore = props.elemBefore,
      elemBefore = _props$elemBefore === void 0 ? null : _props$elemBefore,
      _props$isRemovable = props.isRemovable,
      isRemovable = _props$isRemovable === void 0 ? true : _props$isRemovable,
      _props$text = props.text,
      text = _props$text === void 0 ? '' : _props$text,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color,
      href = props.href,
      isRounded = props.isRounded,
      isLink = props.isLink,
      _props$linkComponent = props.linkComponent,
      Link = _props$linkComponent === void 0 ? 'a' : _props$linkComponent,
      linkHoverColor = props.linkHoverColor;

  if (isLink) {
    return jsx(Link, {
      href: href,
      "data-color": color,
      css: [linkStyles(linkHoverColor), isRounded ? roundedBorderStyles : undefined, elemBefore ? hasBeforeStyles : undefined, isRemovable ? hasAfterStyles : undefined]
    }, text);
  } else {
    return jsx("span", {
      css: [textStyles, isRounded ? roundedBorderStyles : undefined, elemBefore ? hasBeforeStyles : undefined, isRemovable ? hasAfterStyles : undefined]
    }, text);
  }
};

export default Content;